export const environment = {
    production: false,
    environmentName: 'qa',
    mobilePresentationEnabled: true,
    webPresentationEnabled: true,
    runtimeConfigUrl: 'https://qa-api.yosiftware.es/runtime-config',
    sessionVersion: '2026-08-24-firebase-auth-v1',
    clientVersion: '1.0.0',
    apiUrl: 'https://qa-api.yosiftware.es/',
    getImgUrl: 'https://qa-api.yosiftware.es/image/get/',
    setImgUrl: 'https://qa-api.yosiftware.es/image/set/'
};
